module.exports = __webpack_public_path__ + "static/media/blog1.22d18b54.jpg";